// extracted by mini-css-extract-plugin
export default {"projectsBlock":"Projects_projectsBlock__pIbID","projectsContainer":"Projects_projectsContainer__6gmSy","projects":"Projects_projects__2H5hp"};